module.exports = __webpack_public_path__ + "static/black_icon-9b7dc893d5b0b286a52e0c7b553f1063.png";